<template>
  <validation-observer ref="refFormObserver">
    <b-row class="mx-0">
      <b-col cols="6">
        <!-- Name -->
        <validation-provider #default="validationContext" name="name" rules="required">
          <b-form-group
            class="text-capitalize"
            :label="$t('hanwha_dvr.name')"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="itemEdit.name"
              :state="getValidationState(validationContext)"
              trim
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="Type" rules="required">
          <b-form-group
            class="text-capitalize"
            :label="$t('camera.type')"
            label-for="id_type"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemEdit.id_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="typeOptions"
              :clearable="false"
              :reduce="(val) => val.value"
              input-id="id_type"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="delayed_record_minutes">
          <b-form-group
            class="text-capitalize"
            :label="$t('camera.previous_time_of_prealarma')"
            label-for="delayed_record_minutes"
          >
            <flat-pickr
              id="delayed_record_minutes"
              class="form-control"
              :state="getValidationState(validationContext)"
              :config="{
                enableTime: true,
                dateFormat: 'H:i:S',
                time_24hr: true,
                noCalendar: true,
                enableSeconds: true,
              }"
              v-model="itemEdit.delayed_record_minutes"
            />
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="forward_record_minutes">
          <b-form-group
            class="text-capitalize"
            :label="$t('camera.later_time_of_prealarma')"
            label-for="forward_record_minutes"
          >
            <flat-pickr
              id="forward_record_minutes"
              class="form-control"
              :state="getValidationState(validationContext)"
              :config="{
                enableTime: true,
                dateFormat: 'H:i:S',
                time_24hr: true,
                noCalendar: true,
                enableSeconds: true,
              }"
              v-model="itemEdit.forward_record_minutes"
            />
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="Tag">
          <b-form-group
            class="text-capitalize"
            label="Tag"
            label-for="id_device_tag"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemEdit.id_device_tag"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="deviceTagsOptions"
              :clearable="false"
              :reduce="(val) => val.value"
              input-id="id_device_tag"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <b-form-group
          class="text-capitalize"
          label="Webviewer URL"
          label-for="Webviewer URL"
        >
          <b-form-input
            :placeholder="defaultWebviewerUrl"
            id="Webviewer_URL"
            v-model="itemEdit.webviewer_url"
            trim
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="timezone">
          <b-form-group
            class="text-capitalize"
            label="Timezone"
            label-for="timezone"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemEdit.timezone"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="timezones"
              :clearable="false"
              :reduce="(val) => val.value"
              input-id="timezone"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <b-form-group
          class="text-capitalize"
          :label="$t('camera_proxy.send_to_seproban')"
        >
          <label class="custom-switch">
            <input
              type="checkbox"
              id="send_to_seproban"
              :checked="!!itemEdit.send_to_seproban"
              @input="itemEdit.send_to_seproban = $event.target.checked"
            />
            <span class="custom-switch-slider"></span>
          </label>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          class="text-capitalize"
          :label="$t('camera_proxy.rtsp_available')"
        >
          <label class="custom-switch">
            <input
              type="checkbox"
              id="rtsp_available"
              :checked="!!itemEdit.rtsp_available"
              @input="itemEdit.rtsp_available = $event.target.checked ? 1 : 0"
            />
            <span class="custom-switch-slider"></span>
          </label>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          class="text-capitalize"
          label="Fisheye"
        >
          <label class="custom-switch">
            <input
              type="checkbox"
              id="is_fisheye"
              :checked="!!itemEdit.is_fisheye"
              @input="itemEdit.is_fisheye = $event.target.checked"
            />
            <span class="custom-switch-slider"></span>
          </label>
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { computed, onMounted,ref } from "@vue/composition-api";
import store from "@/store";

export default {
  components: {
    flatPickr,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    deviceInfo: {
      type: Object,
    },
    isDeviceInfoLoading: {
      type: Boolean,
    },
    itemEdit: {
      type: Object,
    },
    showNoDataMessage: {
      type: Boolean,
    },
    typeOptions: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    //HOOKS
    onMounted(() => store.dispatch('tenant/getDeviceTags'));
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    //DATA
    const timezones = ref([
      { label: "Etc/GMT+12 (GMT-12)", value: "Etc/GMT+12|-12" },
      { label: "Pacific/Pago_Pago (GMT-11)", value: "Pacific/Pago_Pago|-11" },
      { label: "Pacific/Honolulu (GMT-10)", value: "Pacific/Honolulu|-10" },
      { label: "America/Anchorage (GMT-9)", value: "America/Anchorage|-9" },
      { label: "America/Los_Angeles (GMT-8)", value: "America/Los_Angeles|-8" },
      { label: "America/Denver (GMT-7)", value: "America/Denver|-7" },
      { label: "America/Mexico_City (GMT-6)", value: "America/Mexico_City|-6" },
      { label: "America/New_York (GMT-5)", value: "America/New_York|-5" },
      { label: "America/Santiago (GMT-4)", value: "America/Santiago|-4" },
      { label: "America/Sao_Paulo (GMT-3)", value: "America/Sao_Paulo|-3" },
      { label: "America/Noronha (GMT-2)", value: "America/Noronha|-2" },
      { label: "Atlantic/Azores (GMT-1)", value: "Atlantic/Azores|-1" },
      { label: "Europe/London (GMT+0)", value: "Europe/London|+0" },
      { label: "Europe/Paris (GMT+1)", value: "Europe/Paris|+1" },
      { label: "Europe/Athens (GMT+2)", value: "Europe/Athens|+2" },
      { label: "Europe/Moscow (GMT+3)", value: "Europe/Moscow|+3" },
      { label: "Asia/Dubai (GMT+4)", value: "Asia/Dubai|+4" },
      { label: "Asia/Karachi (GMT+5)", value: "Asia/Karachi|+5" },
      { label: "Asia/Dhaka (GMT+6)", value: "Asia/Dhaka|+6" },
      { label: "Asia/Bangkok (GMT+7)", value: "Asia/Bangkok|+7" },
      { label: "Asia/Shanghai (GMT+8)", value: "Asia/Shanghai|+8" },
      { label: "Asia/Tokyo (GMT+9)", value: "Asia/Tokyo|+9" },
      { label: "Australia/Sydney (GMT+10)", value: "Australia/Sydney|+10" },
      { label: "Pacific/Guadalcanal (GMT+11)", value: "Pacific/Guadalcanal|+11" },
      { label: "Pacific/Auckland (GMT+12)", value: "Pacific/Auckland|+12" },
      { label: "Pacific/Apia (GMT+13)", value: "Pacific/Apia|+13" },
      { label: "Pacific/Kiritimati (GMT+14)", value: "Pacific/Kiritimati|+14" },
    ]);

    //COMPUTED
    const defaultWebviewerUrl = computed(() => {
      const dvr = props.itemEdit.hanwha_dvr;

      return `${dvr.http_schema}://${dvr.ip}:1000${props.itemEdit.channel + 1}`;
    });

    const deviceTagsOptions = computed(() => {
      return store.getters["tenant/getDeviceTags"].map((item) => ({
        label: item.name,
        value: item.id,
      }));
    });

    //METHODS
    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }
      const validation = await refFormObserver.value.validate();
      return validation;
    };

    return {
      getValidationState,
      refFormObserver,

      timezones,

      defaultWebviewerUrl,
      deviceTagsOptions,

      withPopper: popperHelper.withPopper,

      validateStep,
    };
  },
};
</script>

<style scoped>
.custom-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  margin: 0;
  cursor: pointer;
}

.custom-switch input[type="checkbox"] {
  position: absolute;
  width: 50px;
  height: 26px;
  opacity: 0;
  z-index: 2;
  cursor: pointer;
  margin: 0;
}

.custom-switch-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d8d6de;
  border-radius: 34px;
  transition: 0.3s;
  pointer-events: none;
}

.custom-switch-slider::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

.custom-switch input[type="checkbox"]:checked ~ .custom-switch-slider {
  background-color: var(--primary);
}

.custom-switch input[type="checkbox"]:checked ~ .custom-switch-slider::before {
  transform: translateX(24px);
}

.custom-switch input[type="checkbox"]:focus ~ .custom-switch-slider {
  box-shadow: 0 0 0 0.2rem rgba(27, 61, 94, 0.25);
}

/* Dark mode */
.dark-layout .custom-switch-slider {
  background-color: #4b4b4b;
}

.dark-layout .custom-switch input[type="checkbox"]:checked ~ .custom-switch-slider {
  background-color: var(--primary);
}
</style>
